import React from "react";
import { Link } from "react-router-dom";

export const SidebarItem = (props) => {
  return (
    <Link
      className={props.isActive ? "sidebar-item-ative" : "sidebar-item"}
      to={props.link}>
      <span>{props.name}</span>
      <i className="far fa-chevron-left"></i>
    </Link>
  );
};
